import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Card } from '../../../components/Card';

import { selectUserId, selectWork } from '../../Api/selectors';
import { selectUser } from '../../Users/selectors';
import { fetchUser } from '../../Users/actions';

import { REQUEST_USER } from '../../Users/constants';

import { formatLicensePlate } from '../../../utils/string';
import cn from 'classnames';
import styles from './CardInfo.module.css';
import { selectActions } from '../../Actions/selectors';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { VBox } from '../../../components/Box';
import { translateCountry } from '../../Companies/translate-countries';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { ArrowDown } from '../../../components/Icon';
import { VehicleStatusCard } from '../../Vehicles/components/CardStatus';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import { VehicleAvatar } from '../../../components/VehicleAvatar';
import { RegplateLabel } from '../../Vehicles/components/RegplateLabel';
import { getDate } from '../../Vehicles/helpers';

dayjs.extend(customParseFormat);

const Container = styled.div`
  width: 100%;
  font-size: 14px;
  h3 {
    font-size: 20px;
  }
  .type {
    color: #6c757d;
  }
  .regplate {
  }

  .secondary-info {
  }
  .secondary-info-list {
    font-weight: 400;
  }

  .address {
    width: 100%;
    border: 1px solid var(--color-new-grey);
    border-radius: 12px;
    padding: 12px;
    margin: 12px;
    .name {
      font-weight: 600;
    }

    &.selected {
      border: 2px solid var(--color-new-secondary);
    }
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class TransportOrderInfoCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  get locale() {
    return this.props.locale;
  }

  renderAddress(address, selected, company_name, manualAddress) {
    return (
      <VBox className={`address ${selected ? 'selected' : ''}`} key={address?.id}>
        {company_name && company_name} <br />
        {manualAddress ? (
          <>
            <div className="name">{this.lbl(`address.type.other`)}</div>
            {manualAddress} <br />
            <br />
          </>
        ) : (
          <>
            <div className="name">{this.lbl(`address.type.${address?.type?.name || 'other'}`)}</div>
            {address?.addressLine1} <br /> {address?.postcode}&nbsp;{address?.city}
            <br />
            {translateCountry(address?.country?.name, this.locale) || ''}
          </>
        )}
      </VBox>
    );
  }

  render() {
    const transportOrder = this.props.transportOrder;
    const vehicle = this.props.transportOrder?.vehicle;
    const companyFromLabel = transportOrder?.companyFromManual
      ? transportOrder?.companyFromManual
      : transportOrder?.companyFrom?.name;

    const companyToLabel = transportOrder?.companyToManual
      ? transportOrder?.companyToManual
      : transportOrder?.companyTo?.name;

    return (
      <Card className={cn('vehicle-info-card info-card info', styles.card)}>
        <Container width={window.innerWidth}>
          <h2 className="card-title mb-0 text-muted">{this.lbl('transport_order.info_card')}</h2>
          
          <div className={styles.titleContainer}>
            <div className={styles.titleContainer}>
              <h3 className={styles.brandName}>
                {vehicle.brand_name}&nbsp;{vehicle.model_name}
              </h3>
              <h3 className={styles.modelInfo}>
                {vehicle?.model_info}&nbsp;{vehicle?.type}&nbsp;{vehicle?.articlecode}
              </h3>
              <h3 className={styles.modelInfo}>
                <RegplateLabel regplate={vehicle?.regplate} />
              </h3>
            </div>
            <div className={styles.infoBox}>
              <span className={styles.infoVehicle}>{formatLicensePlate(vehicle?.regplate)}</span>
              <span className={styles.infoVehicle}>{parseInt(vehicle?.mileage || '0').toLocaleString() + ' km'}</span>
              <span className={styles.infoVehicle}>{getDate(vehicle?.date_first_allowance)}</span>
            </div>

          </div>
          <div className={'d-flex flex-column justify-content-center align-items-center w-100'}>
            {this.renderAddress(transportOrder?.addressFrom, true, companyFromLabel, transportOrder?.addressFromManual)}
            <div>
              <ArrowDown />
            </div>

            {this.renderAddress(transportOrder?.addressTo, true, companyToLabel, transportOrder?.addressToManual)}
          </div>
          <div className={styles.infoBox}></div>

        </Container>
      </Card>
    );
  }
}

TransportOrderInfoCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loggedInUserId: selectUserId(),
    changedStatusUser: selectUser(ownProps.vehicle?.user_changed_status),
    work: selectWork(REQUEST_USER),
    actions: selectActions(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(id, callback) {
      dispatch(fetchUser(id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrderInfoCard = compose(withConnect, withRouter)(TransportOrderInfoCardComp);
